import React from 'react';
import PropTypes from 'prop-types';
import { numberFormat } from '@fiverr-private/localization';
import { appTranslate } from '../../utils';
import InlineStarSvg from './inlineStarSvg';
import { MAX_COUNT } from './constants';
import './index.scss';

const Rating = ({ rating, count }) => {
    if (!rating) {
        return <div className="rating-wrapper"></div>;
    }
    const formattedRating = numberFormat(rating, { fallbackValue: rating, minimumFractionDigits: 1 });
    const formattedCount = count > MAX_COUNT ? Math.floor(count / 1000) : count;
    const countText =
        count > MAX_COUNT
            ? appTranslate('gig_listings.gig_cards.count_format', { params: { count: formattedCount } })
            : formattedCount;

    return (
        <div className="rating-wrapper">
            <span className="gig-rating text-body-2">
                <InlineStarSvg />
                {formattedRating}
                <span>{countText}</span>
            </span>
        </div>
    );
};

Rating.propTypes = {
    rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    count: PropTypes.number,
};

export default Rating;
